<template>
  <div id="tutorials" class="md-layout-column">
    
    <div class="md-layout md-gutter md-alignment-center-space-between" style="padding-top:40px;padding-left:20px;padding-right:40px;">
      <div class="md-layout-item md-size-80"><h2 class="tab-title" style="margin-bottom:20px">{{ 'Tutorials' }}</h2></div>
      <md-field class="md-layout-item  md-size-20">
          <label>Search video</label>
          <md-input v-model="searchText" @change="filterTutorial" />
      </md-field>
    </div>
    <hr>
      <md-list>
        <md-list-item  @click="showVideoDialog=true;selectedTutorial===tutorial.id"  v-for="tutorial in tutorials" v-bind:key="tutorial.id" style="cursor:pointer;">
          <div class="md-layout md-gutter md-alignment-center-left" style="padding:40px;">
            <div class="md-layout-item md-size-20" >
                <video v-if="tutorial.id==='dashboard'" readonly style="width: 95%"><source src='../assets/Dashboard_Tutorial_Vol1.mp4' type="video/mp4"></video>
            </div>
            <div class="md-layout-item md-size-80" style="cursor:pointer;">
              <h3 style="padding-top: 20px">{{tutorial.title}}</h3>
              <p>{{tutorial.description}}</p>
            </div>
          </div>         
        </md-list-item>
    </md-list>

    <md-dialog :md-active.sync="showVideoDialog">
      <md-dialog-title class="md-dialog-title">Dashboard Tutorial Video</md-dialog-title>
      <div class="dialog-content spaced"  v-if="showVideoDialog"> 
        <video width="1024" height="768" controls v-if="selectedTutorial==='dashboard'"> 
            <source src='../assets/Dashboard_Tutorial_Vol1.mp4' type="video/mp4">
        </video>
      </div>
      <md-dialog-actions>
          <md-button class="md-accent" @click="showVideoDialog = false">Close</md-button>

      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
    import Vue from "vue";

    export default {
      data ()   {
        return {
          showVideoDialog: false,
          searchText : '',
          selectedTutorial: 'dashboard',
          allTutorials:[
            {
              'id':'dashboard',
              'title' : 'Dashboard Module',
              'description' : 'This video, explains how to navigate through the Dashboard module, its different charts, tables and filters.',
              'videoURL' : '../assets/Dashboard_Tutorial_Vol1.mp4',
            }
          ],
          tutorials:[]
        }
      },
      methods:{
        getPermission(name){
          const permissions = Vue.prototype.$userData.permissions|| [];
          if ( !permissions.includes(name)) {
                this.$router.push("Landing");
            }
        },
        filterTutorial(){
          if(this.searchText !== ''){


            this.tutorials=this.allTutorials.filter((tutorial)=>{
    if(this.searchText.indexOf('*') == -1){

      return tutorial.id.toLowerCase().includes(this.searchText.toLowerCase())  || 
               tutorial.title.toLowerCase().includes(this.searchText.toLowerCase()) || 
               tutorial.description.toLowerCase().includes(this.searchText.toLowerCase()) 
    }else{
      return this.$matchWildcardRule(tutorial.title.toLowerCase(), this.searchText.toLocaleLowerCase()) || this.$matchWildcardRule(tutorial.description.toLowerCase(), this.searchText.toLocaleLowerCase());
    }
  
  })



          }else{
            this.tutorials = this.allTutorials;
          }
        }
      },
      created(){
        this.getPermission('tutorials');
        this.tutorials = this.allTutorials;
      }
    }   
</script>

<style lang="scss">

  .dialog-content{
    padding: 0px;
    
    &.spaced{
      overflow-y: auto;
      margin: 20px;
    }
    
  }

</style>